"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = void 0;
var routes_1 = require("../../../constants/routes");
exports.ROUTE = routes_1.STATS;
//# sourceMappingURL=params.js.map